import { rgba } from 'polished';
import { ColorScheme } from 'shared/assets/styles/theme/color-schemes';
import { typographyToCss } from 'shared/lib/mui';
import { QueryNavLink } from 'shared/lib/react-router-dom';
import styled, { css } from 'styled-components';

const LinkBase = css<{ $prominent?: boolean }>`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};

  min-width: 0;
  width: 100%;
  padding: ${({ theme }) => `${theme.spacing(1.5)} ${theme.spacing(3)}`};

  border-radius: ${({ theme }) => theme.spacing(2.5)};

  color: ${({ theme, $prominent }) =>
    $prominent
      ? theme.palette.primaryExtended.opacityBackgroundText
      : rgba(
          theme.palette.text.primary,
          theme.colorScheme === ColorScheme.Dark ? 0.6 : 0.8,
        )};

  &:focus {
    outline: none;
    background: ${({ theme }) => rgba(theme.palette.text.primary, 0.06)};
  }
`;

export const DisabledLink = styled.span<{
  $isMoving?: boolean;
  $prominent?: boolean;
}>`
  ${LinkBase};
  opacity: ${({ $isMoving }) => ($isMoving ? 0.5 : 1)};

  ${({ $prominent }) =>
    $prominent &&
    css`
      &:hover {
        background: ${({ theme }) => rgba(theme.palette.text.primary, 0.06)};
      }
    `};
`;

export const Link = styled(QueryNavLink)<{
  $active: boolean;
  $isMoving?: boolean;
  $prominent?: boolean;
}>`
  ${LinkBase};
  text-decoration: none;

  opacity: ${({ $isMoving }) => ($isMoving ? 0.5 : 1)};

  ${({ $active }) =>
    $active &&
    css`
      ${({ theme }) => typographyToCss(theme.typography.subtitle2)};
      background: ${({ theme }) => rgba(theme.palette.text.primary, 0.06)};
      color: ${({ theme }) => theme.palette.text.primary};

      &:focus {
        background: ${({ theme }) => rgba(theme.palette.text.primary, 0.06)};
        color: ${({ theme }) => theme.palette.text.primary};
      }
    `};

  ${({ $active }) =>
    !$active &&
    css`
      &:hover {
        background: ${({ theme }) => rgba(theme.palette.text.primary, 0.06)};
      }
    `}
`;

export const SubItemIcon = styled.span<{
  $active: boolean;
  $prominent?: boolean;
}>`
  color: ${({ theme, $prominent }) =>
    $prominent
      ? theme.palette.primaryExtended.opacityBackgroundText
      : rgba(theme.palette.text.primary, 0.7)};
  font-size: 1.6rem;
  line-height: 62.5%;
`;

export const LinkTitle = styled.span`
  flex: 1;

  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const EndContainer = styled.span`
  display: flex;
  align-items: center;
`;

export const Content = styled.span`
  line-height: 62.5%;
  margin-right: ${({ theme }) => theme.spacing(1)};
`;

export const Action = styled.span`
  width: 0;
  opacity: 0;
  margin-left: 0;
  overflow: hidden;

  transition:
    width 200ms,
    opacity 200ms,
    margin-left 200ms;

  ${Link}:hover & {
    width: 2.2rem;
    opacity: 1;
    margin-left: ${({ theme }) => theme.spacing(1)};
  }
`;

export const End = styled.span`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.palette.grey[600]};
  margin-left: ${({ theme }) => theme.spacing(1)};
`;
